/** One automatic tour per account, never per tab or content version. */
export function createFirstVisit({storage, uid, claim, show, ready}) {
  const finished=new Set(); let busy=false, pending=null;
  return async function maybeShow() {
    const user=uid(); if(!user || busy || finished.has(String(user)) || !ready())return;
    busy=true;
    const key=`rv_web_welcome_${user}`;
    try {
      if(pending===String(user)){await show();pending=null;finished.add(String(user));return;}
      if(await storage.get(key)==='1'){finished.add(String(user));return;}
      // Existing players who have already opened a guide should not be re-taught.
      const previous=await storage.get(`rv_guide_${user}_profile_v1`);
      const result=await claim();
      if(typeof result?.show!=='boolean')return;
      await storage.set(key,'1');
      if(!result.show || previous){finished.add(String(user));return;}
      pending=String(user);
      if(ready() && String(uid())===pending){await show();pending=null;finished.add(String(user));}
    } catch { /* Failed auth/network never opens a tutorial over a broken screen. */ }
    finally {busy=false;}
  };
}
